import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ClerkProvider } from '@clerk/clerk-react';
import 'antd/dist/reset.css';
import './styles.css';
import { App } from './app.js';

const publishableKey = import.meta.env['VITE_CLERK_PUBLISHABLE_KEY'];
const apiUrl = import.meta.env['VITE_PIPETIN_API_URL'];
if (!publishableKey || !apiUrl) {
  throw new Error(
    'VITE_CLERK_PUBLISHABLE_KEY and VITE_PIPETIN_API_URL are required',
  );
}

const root = document.getElementById('root');
if (!root) throw new Error('The application root element is missing');

createRoot(root).render(
  <StrictMode>
    <ClerkProvider publishableKey={publishableKey}>
      <App apiUrl={apiUrl} />
    </ClerkProvider>
  </StrictMode>,
);
